module.exports = __webpack_public_path__ + "static/valeria-ee9b24069f9195a814c929df4b7817ba.png";